import React, { FC, ReactNode } from 'react';
import { StyledDivider, StyledBlock } from './Tile.styles';
import T3 from '../../titles/T3';

export interface TileProps {
  /** The tile's content */
  children?: ReactNode;
  /** the tile title */
  title?: string;
  /** the tile titleAs */
  titleAs?: string;
  /** If the tile should contain the divider */
  isDivided?: boolean;
}

const TileDefaultProps = {
  isDivided: true,
};

const Tile: FC<TileProps> = ({ children, title, isDivided, titleAs, ...props }) => (
  <StyledBlock white {...props}>
    {title && <T3 as={titleAs}>{title}</T3>}
    {isDivided && <StyledDivider />}
    {children}
  </StyledBlock>
);

Tile.defaultProps = TileDefaultProps;

export default Tile;
